import { DEFAULT_LAYOUT } from '../base';
import type { AppRouteRecordRaw } from '../types';
import { IconTool } from '@arco-design/web-vue/es/icon';

const routes: AppRouteRecordRaw = {
  path: '/tools',
  redirect: '/tools/image-bed',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '实用工具',
    icon: IconTool,
    order: 10000,
    roles: ['utilizer'],
  },
  children: [
    {
      path: 'image-bed',
      component: () => import('@/views/tools/image-bed/index.vue'),
      meta: {
        title: '图床服务',
      },
    },
  ],
};

export default routes;
